var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app-layout" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showFilters,
              expression: "( !showFilters )",
            },
          ],
          staticClass: "show-filters",
          on: {
            click: function ($event) {
              return _vm.toggleShowFilters()
            },
          },
        },
        [_c("img", { attrs: { src: "/img/grey-right.svg" } })]
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("flash-message", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.flashMessage,
                expression: "flashMessage",
              },
            ],
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("nav", { staticClass: "top-navigation" }, [
        _c("div", { staticClass: "grid-x" }, [
          _c("div", { staticClass: "large-5 medium-5 small-4 cell" }, [
            _vm.app_env == "local" || _vm.app_env == "development"
              ? _c("span", { staticClass: "development-label" }, [
                  _vm._v(
                    "\n                    Testovací prostředí\n                "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "filters",
                class: { active: _vm.showFilters },
                on: {
                  click: function ($event) {
                    return _vm.toggleShowFilters()
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "chevron",
                  attrs: { src: "/img/chevron-right.svg" },
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "chevron-active",
                  attrs: { src: "/img/chevron-right-active.svg" },
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("filter.showChargingStationFiltersButton")) +
                    "\n                "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "large-2 medium-2 small-4 cell" }, [
            _c(
              "div",
              {
                staticClass:
                  "logo-current-type-block flex-container flex-dir-column align-center-middle",
              },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "charging-stations" } } },
                  [
                    _c("img", {
                      staticClass: "logo",
                      attrs: {
                        src: "/img/logo-navigation-drivalia.svg",
                        alt: "Drivalia",
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "large-5 medium-5 small-4 cell" }, [
            _c("img", {
              staticClass: "hamburger",
              attrs: { src: "/img/hamburger.svg" },
              on: {
                click: function ($event) {
                  return _vm.setShowPopOut()
                },
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "language-switch-container-view" },
              [_c("lang-switcher")],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "logout",
                on: {
                  click: function ($event) {
                    return _vm.logout()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("auth.logoutButton")))]
            ),
            _vm._v(" "),
            _vm.licensePlate
              ? _c("div", { staticClass: "license-plate-container-view" }, [
                  _c("span", { staticClass: "license-plate-view" }, [
                    _vm._v(_vm._s(_vm.licensePlate)),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("charging-station-filters"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page", attrs: { id: "charging-station" } },
        [
          _c("fullscreen-loader", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.chargingStationsLoadStatus == 1,
                expression: "chargingStationsLoadStatus == 1",
              },
            ],
          }),
          _vm._v(" "),
          _c("charging-station-map"),
          _vm._v(" "),
          _c("router-view"),
          _vm._v(" "),
          _c("charging-station-legend"),
          _vm._v(" "),
          _c("switch-type-modal"),
          _vm._v(" "),
          _c("pop-out"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }